import { useEffect } from 'react';
import { PAYMENT_TYPES } from '../../constants';
import { paymentsActions } from '../../store';

const { SET_ACTIVE_PAYMENT_TYPE } = paymentsActions;

export const useSetActivePaymentType = (type = PAYMENT_TYPES.DEPOSIT) => {
  useEffect(() => {
    SET_ACTIVE_PAYMENT_TYPE(type);
  }, [type]);
};
